import { Injectable } from '@angular/core';
import { ExpenseTypeModel } from './model/expense-type.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class ExpenseTypeService {

  constructor(private http: HttpClient) { }

  // getExpenseList(requestData:RequestData): Observable<any> {
  //   return this.http.post(environment.baseUrl+'/expense/get', requestData);

  // }

  getExpenseType(requestData:any): Observable<any> {
    return this.http.post(environment.baseUrl+'/expense-type/get', requestData);

  }

  getExpenseById(id:number): Observable<any> {
    return this.http.post(environment.baseUrl+'/expense-type/get/'+id, '');

  }

   /**
   * 
   * @param expenseTypeInfo 
   * Calls the update API to insert/update the record
   */
   update(expenseTypeInfo: ExpenseTypeModel): Observable<any> { 
    if(expenseTypeInfo.hasOwnProperty("id")){
      return this.http.post(environment.baseUrl+'/expense-type/update', expenseTypeInfo);
    } else{
      return this.http.post(environment.baseUrl+'/expense-type/add', expenseTypeInfo);
    }
  }


    /**
   * 
   * @param expenseTypeInfo 
   * Calls the API to delete the record
   */
    delete(expenseTypeInfo: ExpenseTypeModel): Observable<any>  {
      // alert();
      return this.http.post(environment.baseUrl+'/expense-type/delete/'+expenseTypeInfo.id, expenseTypeInfo);
    }

    // downloadExcel(requestData: any): Observable<Blob> {
    //   const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    //  // const url = 'http://yourdomain.com/api/customers/export'; // Adjust URL
  
    //   return this.http.post(environment.baseUrl + '/department/export-department-list', requestData, { headers, responseType: 'blob' })
    //     .pipe(
    //       //catchError(this.handleError)
    //     );
  
    // }

}
